import { useEffect, useState } from "react";
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { translate } from "react-switch-lang";

import { useHttpClient } from "../../security/hooks/axiosProvider";
import VideoType from "./video-type/videoType";
import TypeDocument from "./type-document/typeDocument";
import Footer from "../template/footer";
import { ThematicDto } from "../../models/thematicDto";
import { DocumentTypeDto } from "../../models/documentTypeDto";
import { VideoTypeDto } from "../../models/videoTypeDto";
import styles from "./parametre.module.scss";
import Country from "./country/country";
import Thematique from "./thematique/thematique";
import Header from "../header/header";
import { Link } from "react-router-dom";
import { Home as IconHome } from "react-feather";

const Parametre = (props: any) => {
  const httpClient = useHttpClient(true);
  const [VerticleTab, setVerticleTab] = useState("1");
  const [listThematic, setListThematic] = useState<ThematicDto[]>([]);
  const [listDocument, setListDocument] = useState<DocumentTypeDto[]>([]);
  const [listVideo, setListVideo] = useState<VideoTypeDto[]>([]);
  const [listCountry, setListCountry] = useState<VideoTypeDto[]>([]);

  useEffect(() => {
    httpClient.current?.get("/thematic").then(response => {
      setListThematic(response.data);
    });

    httpClient.current?.get("/document").then(response => {
      setListDocument(response.data);
    });

    httpClient.current?.get("/video_type").then(response => {
      setListVideo(response.data);
    });
  }, [httpClient]);

  return (
    <>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          <div className={`${styles["agrisud-page-body"]} page-body`}>
            <Container fluid>
              <div className="page-title">
                <Row>
                  <Col xs="6">
                    <Breadcrumb>
                      <BreadcrumbItem>
                        <Link to={`/`}>
                          <IconHome />
                        </Link>
                      </BreadcrumbItem>
                      <BreadcrumbItem active>Paramétrage</BreadcrumbItem>
                    </Breadcrumb>
                  </Col>
                </Row>
                <br />
                <br />
                <Row></Row>
              </div>

              <Card>
                <CardBody>
                  <Row>
                    <Col sm="3" xs="12">
                      <Nav className="nav flex-column nav-pills">
                        <NavItem>
                          <NavLink href="#javascript" className={VerticleTab === "1" ? "active" : ""} onClick={() => setVerticleTab("1")}>
                            {props.t("thematic.label_thematic")}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink href="#javascript" className={VerticleTab === "2" ? "active" : ""} onClick={() => setVerticleTab("2")}>
                            {props.t("country.label_country")}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink href="#javascript" className={VerticleTab === "3" ? "active" : ""} onClick={() => setVerticleTab("3")}>
                            {props.t("document_type.label_document_type")}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink href="#javascript" className={VerticleTab === "4" ? "active" : ""} onClick={() => setVerticleTab("4")}>
                            {props.t("video_type.label_video_type")}
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>
                    <Col sm="9" xs="12">
                      <TabContent activeTab={VerticleTab}>
                        <TabPane className="fade show" tabId="1">
                          <div>
                            <Thematique listThematic={listThematic} setListThematic={setListThematic} />
                          </div>
                        </TabPane>
                        <TabPane tabId="2">
                          <div>{<Country listCountry={listCountry} setListCountry={setListCountry}></Country>}</div>
                        </TabPane>
                        <TabPane tabId="3">
                          <div>
                            <TypeDocument listTypeDocument={listDocument} setListTypeDocument={setListDocument} />
                          </div>
                        </TabPane>
                        <TabPane tabId="4">
                          <div>
                            <VideoType listVideoType={listVideo} setListVideoType={setListVideo} />
                          </div>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default translate(Parametre);
